module.exports = __webpack_public_path__ + "static/media/4. Tierras, Mixta sobre hierro, 53 x 35 cm, 2013 copy.09ffde6b.png";